import React from 'react';

import Link from 'next/link';

import { getRoute, ROUTE } from '@services/http/Route';

import css from './LeftSide.module.scss';

type LeftSideProps = {
    children: React.ReactNode;
};

const LeftSide = ({ children }: LeftSideProps) => {
    return (
        <div className={css.left_side_wrapper}>
            <Link href={getRoute(ROUTE.LPC.HOME)} className={css.logo}>
                <img src="/front-static/icons/logo/lpc.svg" alt="LPC logo" />
            </Link>
            {children}
        </div>
    );
};

export default LeftSide;
